// // src/Pages/HomePage.js
import React, { useState, useEffect } from 'react';

const HomePage = ({ setCurrentPage }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const carouselItems = [
    {
      illustration: 'images/products.png',
      title: 'Scalable Platforms',
      description: 'From startups to enterprises, we empower businesses with scalable, innovative, and cost-effective technology solutions. With a commitment to excellence, Celerity Technocrats delivers reliable software products that accelerate growth and digital transformation.',
      linkText: 'Read More',
      linkPage: 'services',
      bgGradient: 'from-blue-900 to-indigo-900',
    },
    {
      illustration: 'images/Freelancer.png',
      title: 'Remote Manpower Solutions',
      description: 'Access skilled Delphi, C#, React, and WordPress experts for dedicated or shared projects. Our remote teams integrate seamlessly to drive your projects forward with efficiency and expertise.',
      linkText: 'Hire Our Talent',
      linkPage: 'services',
      bgGradient: 'from-blue-900 to-indigo-900',//'from-green-900 to-teal-900',
    },
    {
      illustration: 'images/webdesign.png',
      title: 'Stunning Website Design',
      description: 'Crafting responsive, user-friendly websites that elevate your online presence and drive engagement. We focus on modern design principles and robust functionality to create an exceptional user experience.',
      linkText: 'Design Your Website',
      linkPage: 'services',
      bgGradient: 'from-blue-900 to-indigo-900',//'from-purple-900 to-pink-900',
    },
    {
      illustration: 'images/globalp.png',
      title: 'Global Excellence, Local Impact',
      description: 'Delivering world-class solutions with a 99.99% on-time delivery ratio, serving clients worldwide. Our global network ensures that we provide exceptional value and support, wherever you are.',
      linkText: 'Learn About Us',
      linkPage: 'about',
      bgGradient: 'from-blue-900 to-indigo-900', //'from-orange-900 to-red-900',
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % carouselItems.length);
    }, 5000); // Change slide every 5 seconds
    return () => clearInterval(interval);
  }, [carouselItems.length]);

  const goToPrevSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide - 1 + carouselItems.length) % carouselItems.length);
  };

  const goToNextSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide + 1) % carouselItems.length);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50">
      {/* Full-width Carousel with S-curve */}
      <div className="relative w-full overflow-hidden mb-12">
        <div className="relative h-96 md:h-[500px] lg:h-[600px]">
          {carouselItems.map((item, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 ease-in-out
                ${index === currentSlide ? 'opacity-100' : 'opacity-0'}
                ${`bg-gradient-to-br ${item.bgGradient}`}
                flex flex-col-reverse md:flex-row items-center justify-center text-white p-8`}
            >
              {/* Left Section: Text Content */}
              <div className="relative z-10 w-full md:w-1/2 flex flex-col items-center md:items-start justify-center p-4 text-center md:text-left">
                <h2 className="text-3xl md:text-5xl font-extrabold mb-4 leading-tight drop-shadow-lg">
                  {item.title}
                </h2>
                <p className="text-lg md:text-xl mb-6 max-w-2xl text-gray-200 drop-shadow-md carousel-desc">
                  {item.description}
                </p>
                <button
                  onClick={() => setCurrentPage(item.linkPage)}
                  className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-full shadow-lg transition-all duration-300 ease-in-out transform hover:scale-105 hover:shadow-xl border-2 border-blue-600 hover:border-blue-800"
                >
                  {item.linkText}
                </button>
              </div>
              {/* Right Section: Seamless Illustration */}
              <div
                className="relative z-10 w-full md:w-1/2 h-full bg-no-repeat bg-center bg-contain"
                style={{ backgroundImage: `url(${item.illustration})` }}
                aria-label={`Illustration for ${item.title}`}
              >
              </div>
            </div>
          ))}
        </div>

        {/* Carousel Navigation Buttons */}
        <button
          onClick={goToPrevSlide}
          className="absolute top-1/2 left-4 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-3 rounded-full hover:bg-opacity-75 transition-all duration-300 z-10 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-75"
          aria-label="Previous slide"
        >
          &#10094; {/* Left arrow */}
        </button>
        <button
          onClick={goToNextSlide}
          className="absolute top-1/2 right-4 transform -translate-y-1/2 bg-black bg-opacity-50 text-white p-3 rounded-full hover:bg-opacity-75 transition-all duration-300 z-10 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-75"
          aria-label="Next slide"
        >
          &#10095; {/* Right arrow */}
        </button>

        {/* Carousel Indicators */}
        <div className="absolute bottom-4 left-0 right-0 flex justify-center space-x-2 z-10">
          {carouselItems.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-3 h-3 rounded-full transition-all duration-300 border border-white
                ${index === currentSlide ? 'bg-white scale-125' : 'bg-gray-400 bg-opacity-75'}`}
              aria-label={`Go to slide ${index + 1}`}
            ></button>
          ))}
        </div>

        {/* S-Curve Separator */}
        <div className="absolute bottom-0 left-0 w-full h-24 overflow-hidden z-0">
          <svg
            className="w-full h-full"
            viewBox="0 0 100 100"
            preserveAspectRatio="none"
          >
            <path
              d="M0,100 C20,0 80,100 100,0 L100,100 L0,100 Z"
              fill="#f8fafc" // Match body background color
            />
          </svg>
        </div>
      </div>

      {/* Our Services Section */}
      <section className="container mx-auto py-16 px-4 sm:px-6 lg:px-8 -mt-24 relative z-10">
        <div className="bg-white rounded-xl shadow-2xl p-8 md:p-12 text-center border border-gray-100 transform transition-all duration-500 hover:scale-[1.01]">
          <h2 className="text-4xl font-extrabold text-gray-900 mb-10 drop-shadow-sm">Our Core Services</h2>
          <p className="text-lg text-gray-700 mb-12 max-w-3xl mx-auto">
            At Celerity Technocrats, we offer a comprehensive suite of services designed to empower your business with cutting-edge technology solutions.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Service Link Card 1 */}
            <div className="bg-blue-50 p-6 rounded-lg shadow-md transform transition-transform duration-300 hover:scale-105 hover:shadow-lg border border-blue-100 cursor-pointer" onClick={() => setCurrentPage('services')}>
              <h3 className="text-2xl font-bold text-blue-800 mb-3">Remote Manpower</h3>
              <p className="text-gray-600 mb-4">
                Dedicated & shared resources for Delphi, C#, React, WordPress, and more.
              </p>
              <span className="text-blue-600 hover:text-blue-800 font-semibold transition-colors duration-300">Learn More &rarr;</span>
            </div>
            {/* Service Link Card 2 */}
            <div className="bg-green-50 p-6 rounded-lg shadow-md transform transition-transform duration-300 hover:scale-105 hover:shadow-lg border border-green-100 cursor-pointer" onClick={() => setCurrentPage('services')}>
              <h3 className="text-2xl font-bold text-green-800 mb-3">Custom App Development</h3>
              <p className="text-gray-600 mb-4">
                Tailored solutions for Web, Desktop, and Mobile platforms.
              </p>
              <span className="text-green-600 hover:text-green-800 font-semibold transition-colors duration-300">Learn More &rarr;</span>
            </div>
            {/* Service Link Card 3 */}
            <div className="bg-purple-50 p-6 rounded-lg shadow-md transform transition-transform duration-300 hover:scale-105 hover:shadow-lg border border-purple-100 cursor-pointer" onClick={() => setCurrentPage('services')}>
              <h3 className="text-2xl font-bold text-purple-800 mb-3">Website Designing</h3>
              <p className="text-gray-600 mb-4">
                Stunning and responsive websites that captivate your audience.
              </p>
              <span className="text-purple-600 hover:text-purple-800 font-semibold transition-colors duration-300">Learn More &rarr;</span>
            </div>
          </div>
          <button
            onClick={() => setCurrentPage('services')}
            className="mt-12 bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-3 px-8 rounded-full shadow-lg transition-all duration-300 ease-in-out transform hover:scale-105 hover:shadow-xl border-2 border-indigo-600 hover:border-indigo-800"
          >
            View All Services
          </button>
        </div>
      </section>

      {/* Why Celerity Section */}
      <section className="container mx-auto py-16 px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-xl shadow-2xl p-8 md:p-12 border border-gray-100 transform transition-all duration-500 hover:scale-[1.01]">
          <h2 className="text-4xl font-extrabold text-gray-900 text-center mb-10 drop-shadow-sm">How Celerity Technocrats is different?</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
            <div className="space-y-6 text-lg text-gray-700">
              <p>
                At Celerity Technocrats, we don't just build software; we forge partnerships that drive innovation and success. Our commitment to excellence is reflected in every project we undertake.
              </p>
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 text-green-600 text-3xl">
                  &#10003; {/* Checkmark icon */}
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900">Unrivaled Technical Excellence</h3>
                  <p>Our team comprises highly skilled professionals proficient in a wide array of modern and legacy technologies, ensuring robust, scalable, and future-proof solutions.</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 text-green-600 text-3xl">
                  &#10003;
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900">99.99% On-Time Delivery</h3>
                  <p>We are meticulously organized and committed to deadlines, boasting an industry-leading on-time project delivery rate that ensures your business stays on track.</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 text-green-600 text-3xl">
                  &#10003;
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900">Global Talent, Local Support</h3>
                  <p>With teams in the USA, UK, Canada, and India, we offer diverse perspectives, round-the-clock support, and a deep understanding of global markets.</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 text-green-600 text-3xl">
                  &#10003;
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900">Flexible Engagement Models</h3>
                  <p>Whether you need dedicated remote manpower, shared resources, or end-to-end custom application development, we adapt to your unique requirements.</p>
                </div>
              </div>
            </div>
            <div className="hidden md:block">
              <img
                src="images/HowDifferent1.png"
                alt="How Celerity Technocrats is different"
                className="rounded-lg shadow-xl w-full h-auto object-cover transform transition-transform duration-300 hover:scale-[1.02] border border-indigo-100"
                onError={(e) => { e.target.onerror = null; e.target.src = 'https://placehold.co/600x400/CCCCCC/333333?text=Image+Loading+Error'; }}
              />
            </div>
          </div>
          <div className="text-center mt-12">
            <button
              onClick={() => setCurrentPage('contact')}
              className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-full shadow-lg transition-all duration-300 ease-in-out transform hover:scale-105 hover:shadow-xl border-2 border-blue-600 hover:border-blue-800"
            >
              Let's Discuss Your Project
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;

// import React from 'react';
// import Carousel from '../Components/Carousel';

// const HomePage = ({ setCurrentPage }) => {
//   return (
//     <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 py-12 px-4 sm:px-6 lg:px-8">
//       <Carousel setCurrentPage={setCurrentPage} />

//       {/* Original Home Page Content (below carousel) */}
//       <div className="width-full place-items-center">
//         <div className="max-w-4xl place-content-center bg-white rounded-xl shadow-2xl p-8 md:p-12 text-center transform transition-all duration-500 hover:scale-[1.01] border border-gray-100">
//         <h1 className="text-5xl font-extrabold text-gray-900 mb-6 leading-tight drop-shadow-sm">
//           Innovating Your Future with <span className="text-blue-700">Celerity Technocrats</span>
//         </h1>
//         <p className="text-xl text-gray-700 mb-8 max-w-2xl mx-auto">
//           Your trusted partner in cutting-edge software development and IT solutions. We deliver excellence, on time, every time.
//         </p>
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-10">
//           <div className="bg-blue-50 p-6 rounded-lg shadow-md transform transition-transform duration-300 hover:scale-105 hover:shadow-lg border border-blue-100">
//             <h3 className="text-2xl font-bold text-blue-800 mb-3">Global Reach</h3>
//             <p className="text-gray-600">
//               Serving clients across the USA, Australia, Georgia, Qatar, India, and the UK. Our solutions know no borders.
//             </p>
//           </div>
//           <div className="bg-green-50 p-6 rounded-lg shadow-md transform transition-transform duration-300 hover:scale-105 hover:shadow-lg border border-green-100">
//             <h3 className="text-2xl font-bold text-green-800 mb-3">Unmatched Reliability</h3>
//             <p className="text-gray-600">
//               Achieving a remarkable <span className="font-semibold text-green-700">99.99% on-time delivery ratio</span>, we ensure your projects are always on schedule.
//             </p>
//           </div>
//         </div>
//         <button
//           onClick={() => setCurrentPage('services')}
//           className="mt-12 bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-full shadow-lg transition-all duration-300 ease-in-out transform hover:scale-105 hover:shadow-xl border-2 border-blue-600 hover:border-blue-800"
//         >
//           Explore Our Services
//         </button>
//       </div>
//       </div>
//     </div>
//   );
// };

// export default HomePage;
